import Resizer from 'react-image-file-resizer'

const resizerImage = (
  file: File,
  maxWidth: number,
  maxHeight: number,
  compressFormat = 'PNG',
  quality = 50,
): Promise<File> =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      compressFormat,
      quality,
      0,
      (uri: File) => {
        resolve(uri)
      },
      'file',
    )
  })

export default resizerImage
